module.exports = __webpack_public_path__ + "img/1.63f56f11.jpg";